<script lang="ts">
    
    import { Link } from "svelte-navigator";
    import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Icon } from "sveltestrap";
    import { endSession } from "../services/session";

    let openSidebar = localStorage.getItem('openSidebar') === '1';

    function toggleSidebar() {
        openSidebar = !openSidebar;
        localStorage.setItem('openSidebar', openSidebar ? '1' : '0');
    }

    function onLogOut() {
        if (!confirm('¿Seguro que deseas salir?')) {
            return;
        }
        endSession();
    }

</script>

<div class="app-wrapper">
    <div class="sidebar" class:open={openSidebar}>

        <div class="logo">
            <img src="/images/logo-checkform-white.png" alt="Check Form">
        </div>

        <ul class="navigation">
            <li>
                <Link class="nav-link" to="/formularios">
                    <Icon class="icon" name="file-post-fill" />
                    <div class="text">Formularios</div>
                </Link>
            </li>
            <li>
                <Link class="nav-link" to="/historial">
                    <Icon class="icon" name="clock-history" />
                    <div class="text">Historial</div>
                </Link>
            </li>
            <li>
                <Link class="nav-link" to="/usuarios">
                    <Icon class="icon" name="people-fill" />
                    <div class="text">Usuarios</div>
                </Link>
            </li>
        </ul>
    </div>
    <div class="content">
        <div class="topbar">
            <Button type="button" color="light" on:click={toggleSidebar}>
                <Icon name={openSidebar ? 'chevron-left' : 'chevron-right'} />
            </Button>
            <Dropdown>
                <DropdownToggle color="light">
                    <Icon name="three-dots-vertical" />
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem on:click={onLogOut}><Icon name="power" /> Salir</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <slot />
    </div>
</div>

<style lang="scss">

    $topbar-height: 54px;

    .app-wrapper {
        display: flex;
        width: 100vw;
        height: 100vh;
    }

    .sidebar {
        width: 50px;
        transition: width 0.5s;
        background-color: var(--bs-primary);
        color: #fff;

        &.open {
            width: 200px;
        }
    }

    .logo {
        height: $topbar-height;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 85%;
        }
    }

    .topbar {
        display: flex;
        justify-content: space-between;
        height: $topbar-height;
        box-sizing: border-box;
        margin: 0 0 1rem;
        padding: 0.5rem;
        background-color: var(--bs-primary);
        color: #fff;
    }

    .content {
        flex: 1 1 0;
        overflow: auto;
        padding-bottom: 1rem;
    }

    .navigation {
        padding-left: 0;

        li {
            list-style: none;
        }

    }

    :global(.sidebar .navigation a) {
        color: #fff;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        width: 100%;

        .text {
            display: none;
        }
    }

    :global(.sidebar.open .navigation .text) {
        display: block !important;
    }

</style>
